import { ListItemText, Stack, Typography } from "@mui/material";

import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { formatTime } from "~/modules/app/util/formatters";

import { ProjectReviewVisitV2FunctionListItemFragment } from "./fragments.generated";

type Props = {
    ecologicalFunction: ProjectReviewVisitV2FunctionListItemFragment;
};

export function ProjectReviewVisitV2FunctionListItem({ ecologicalFunction }: Props) {
    return (
        <Stack direction="row" alignItems="center" width="1">
            <ListItemText>
                <Typography variant="body2">{formatTime(parseStringToDate(ecologicalFunction.createdAt))}</Typography>
                <Typography>{ecologicalFunction.speciesList.map(speciesListItem => speciesListItem.name).join(", ")}</Typography>
            </ListItemText>
        </Stack>
    );
}
